import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/audiences.actions'

const initialState = {
  edit: {},
  list: [],
  filter_text: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.AUDIENCES_SET_EDIT:
      return {
        ...state,
        edit: action.edit,
      }
    case Actions.AUDIENCES_CLEAR_EDIT:
      return {
        ...state,
        edit: {},
      }
    case Actions.AUDIENCES_CLEAR:
      return {
        ...state,
        list: [],
      }
    case Actions.AUDIENCES_ADD_ONE:
      return {
        ...state,
        list: [
          ...state.list.filter(
            (audience) => audience.id !== action.audience.id
          ),
          action.audience,
        ],
      }
    case Actions.AUDIENCES_REMOVE:
      return {
        ...state,
        list: [
          ...state.list.filter((audience) => audience.id !== action.audience),
        ],
      }
    case Actions.AUDIENCES_SET_FILTER_TEXT:
      return {
        ...state,
        filter_text: action.text,
      }
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}
